@if (fGroup) {
  <div class="file-upload" [formGroup]="fGroup">
    <ng-container *ngTemplateOutlet="uploadTemplate"></ng-container>
  </div>
}
@if (!fGroup) {
  <div class="file-upload">
    <ng-container *ngTemplateOutlet="uploadTemplate"></ng-container>
  </div>
}

<ng-template #uploadTemplate>
  <div class="file-not-selected">
    <div class="file-upload-layout">
      <div class="align-left">
        <i class="fal fa-file-upload fa-2x"></i>
      </div>
      <div class="align-left">
        <div class="file-description">
          @if (uploadedCount === 0) {
            No Files Uploaded
          }
          @if (uploadedCount > 0) {
            {{uploadedCount}} File{{uploadedCount === 1 ? '' : 's'}} Uploaded
          }
          @if (pendingCount > 0) {
            , {{pendingCount}} File{{pendingCount === 1 ? '' : 's'}} Pending Upload
          }
        </div>
      </div>
      @if (editable) {
        <div class="align-right">
          @if (fGroup && fControlName) {
            <button type="button" class="btn btn-icon-file-upload"
              (click)="files?.length < fileLimit ? fileInput.click() : $event.preventDefault()"
              [class.btn-disabled]="files?.length === fileLimit" pTooltip="Maximum file count reached"
              [tooltipDisabled]="files?.length < fileLimit">
              Upload
            </button>
            <input #fileInput type="file" [hidden]="true" [id]="fieldID" [name]="fieldName"
              [accept]="acceptTypes" [formControlName]="fControlName" [attr.aria-required]="required"
              [attr.aria-invalid]="invalid" (change)="documentOnSelect($event)">
          }
          @if (!fGroup || !fControlName) {
            <button type="button" class="btn btn-icon-file-upload"
              (click)="files?.length < fileLimit ? fileInput.click() : $event.preventDefault()"
              [class.btn-disabled]="files?.length === fileLimit" pTooltip="Maximum file count reached"
              [tooltipDisabled]="files?.length < fileLimit">
              Upload
            </button>
            <input #fileInput type="file" [hidden]="true" [id]="fieldID" [name]="fieldName"
              [accept]="acceptTypes" [attr.aria-required]="required" [attr.aria-invalid]="invalid"
              (change)="documentOnSelect($event)">
          }
        </div>
      }
    </div>
  </div>
  @if (editable) {
    <div class="mb-3 text-small" [class.form-error-message]="showFileError">
      Maximum of {{fileLimit}} documents allowed. Files must be less than {{maxFileSizeMB}}MB and be one
      of the following formats: {{acceptTypes}}.
    </div>
  }
  @if (files?.length) {
    <p-table [value]="files" class="table table-striped table-sm"
      [lazy]="false" [paginator]="false" [totalRecords]="files?.length" [rows]="100">
      <ng-template pTemplate="header">
        <tr>
          <th>Status</th>
          <th>Document Name</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            @if (item.isUploaded) {
              <app-status-indicator text="Uploaded" status="active" dots="true">
              </app-status-indicator>
            }
            @if (!item.isUploaded) {
              <app-status-indicator text="Save to Upload" status="warning"
                dots="true">
              </app-status-indicator>
            }
          </td>
          <td>
            {{item.uploadedDocumentName}}
          </td>
          <td>
            <button type="button" class="btn btn-sm btn-circle"
              (click)="toggleDocumentOptionsMenu(item, $event)">
              <i class="fa fa-ellipsis-h"></i>
              <span class="sr-only">
                Options
              </span>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</ng-template>

<p-menu #menu appendTo="body" [model]="documentOptions" [popup]="true" [style]="{ 'width': 'auto'}">
</p-menu>
@if (editable) {
  @if (editingDocument) {
    <p-dialog header="Confirm Remove" [(visible)]="showDocumentDelete" [modal]="true"
      [closable]="false" [draggable]="false" [styleClass]="'shortWidthDialog'" blockScroll="true">
      Are you sure you want to {{editingDocument.isUploaded ? 'delete' : 'remove'}} this document?
      <ng-template #footer>
        <button class="btn btn-primary" (click)="deleteDocument()" [disabled]="deletingDocument">
          @if (deletingDocument) {
            <span class="spinner-border spinner-border-sm"></span>
            <span role="status">Removing...</span>
          } @else {
            Yes, remove
          }
        </button>
        <button (click)="showDocumentDelete = false" class="btn btn-secondary" [disabled]="deletingDocument">
          No
        </button>
      </ng-template>
    </p-dialog>
  }
}
